import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
export * from "../shared/lib/utils/format"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
